import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ShieldFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11z"
      fill="currentColor"
    />
  </svg>
);

ShieldFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ShieldFilledIcon);
